import { Vector2 } from "three";
import { OnAnimationFrame } from "../../animation/OnAnimationFrame";
import { UIInteraction } from "./UIInteraction";
import { UIInteractionEvent } from "./UIInteractionEvent";

export class UIInteractionController<I extends UIInteraction<E>, E extends UIInteractionEvent> 
{
  _interactions:I[] = null;
  _focused:I = null;
  _event:E;
  _onAnimationFrame:OnAnimationFrame = new OnAnimationFrame();
  _running = false;


  initialize( e:E, interactions:I[] )
  {
    this._event = e;
    this._interactions = interactions;
  }

  /*
  startUpdater()
  {
    if ( this._running )
    {
      return;  
    }

    this._onAnimationFrame.addListener( ()=> this.update );
    this._onAnimationFrame.run();
    

    this._running = true;
  }*/

  update()
  {
    this._event.update();

    if ( this._focused )
    {
      console.log( "FOCUSED:", this._focused );
      this._focused.update( this._event );
      return;
    }


    for ( let i = 0; i < this._interactions.length; i++ )
    {
      this._interactions[ i ].update( this._event );

      if ( this._event.consumed )
      {
        return;
      }
    }

  }

  isFocused( interaction:I )
  {
    return this._focused == interaction;
  }

  blur()
  {
    if ( ! this._focused )
    { 
      return;
    }

    let blurred = this._focused;
    this._focused = null;

    blurred.onBlur();
    
  }

  focus( interaction:I )
  {
    if ( this._focused == interaction )
    {
      return;
    }

    if ( this._focused )
    {
      let blurred = this._focused;
      this._focused = null;
      blurred.onBlur();
    }
    
    this._focused = interaction;

    if ( this._focused )
    {
      this._focused.onFocus();
    }
    
  } 



}